import math from "core/math";
import makeKey from "core/cache/KeyGen.js";
//import { clearToolOptionsByElement } from "../toolOptions.js";
import { getEnabledElement } from "component/toolManager/enabledElements.js";
import EVENTS from "core/customEvent/events";
import Cache from "core/cache/index";
import Helper from "helper";
/**
 * Return an array filtered to only its unique members
 *
 * @private
 * @param {Array} array - The array to filter
 * @returns {Array}
 */
function unique(array) {
  return array.filter(function (value, index, self) {
    return self.indexOf(value) === index;
  });
}

/**
 * Synchronize target and source elements when an event fires on the source element
 * @export @public constructor
 * @name Synchronizer
 *
 * @param {String} event - The event(s) that will trigger synchronization. Separate multiple events by a space
 * @param {Function} handler - The function that will make the necessary changes to the target element in order to synchronize it with the source element
 * @returns {void}
 */
function Synchronizer(event, handler) {
  //const cornerstone = external.cornerstone;
  const that = this;
  //const sourceElements = []; // Source elements fire the events we want to synchronize to
  //const targetElements = []; // Target elements we want to synchronize to source elements
  let mapSourceToElements = new Map();

  let ignoreFiredEvents = false;
  const initialData = {};
  let eventHandler = handler;
  let _containerElement = null;

  this.enabled = true;

  this.getEnabled = function () {
    return this.enabled;
  };
  this.setEnabled = function (enabled) {
    this.enabled = enabled;
  };

  /**
   * Update the event handler to perform synchronization
   * @param {Function} handler - The event handler function
   * @returns {void}
   */
  this.setHandler = function (handler) {
    eventHandler = handler;
  };

  /**
   * Return a reference to the event handler function
   * @returns {Function}
   */
  this.getHandler = function () {
    return eventHandler;
  };

  this.initialDistance = function (sourceElement) {
    if (!sourceElement || !mapSourceToElements.size === 0) {
      return;
    }

    initialData.distances = {};
    initialData.imageIds = {
      mapSourceToTarget: new Map(),
      // sourceElements: [],
      // targetElements: []
    };
  };

  /**
   * Calculate the initial distances between the source image and each
   * of the target images
   * @returns {void}
   */
  this.getDistances = function (sourceElement) {
    if (!sourceElement || !mapSourceToElements.size === 0) {
      return;
    }
    if (!initialData.hasOwnProperty("distances")) {
      initialData.distances = {};
    }
    initialData.imageIds = {
      mapSourceToTargets: new Map(),
    };

    const sourceElementStub = getEnabledElement(sourceElement);

    if (!sourceElementStub || !sourceElementStub.image) {
      return;
    }

    const sourceImageId = sourceElementStub.image.sopInstanceUID;

    const sourceSeriesKey = makeKey(
      sourceElementStub.image.seriesInstanceUID,
      sourceElementStub.image.modality
    );

    let metadataCache = new Cache.Metadata();
    let sourceImagePlane = metadataCache.getImagePlaneModule(sourceSeriesKey);

    if (!sourceImagePlane || sourceImagePlane.imagePositionPatient) {
      let string = "";
    }

    sourceImagePlane.imagePositionPatient =
      sourceElementStub.image.imagePosition;

    if (!sourceImagePlane || !sourceImagePlane.imagePositionPatient) {
      return;
    }

    const sourceImagePosition = math.vector.convertToVector3(
      sourceImagePlane.imagePositionPatient
    );

    if (initialData.hasOwnProperty(sourceElementStub)) {
      return;
    }
    //initialData.distances[sourceImageId] = {};\
    initialData.distances[sourceElement.id] = {};
    //initialData.imageIds.sourceElements.push(sourceElement);
    initialData.imageIds.mapSourceToTargets[sourceElement] = [];

    const targetElements = mapSourceToElements.get(sourceElement);

    targetElements.forEach(function (targetElement) {
      const targetElementStub = getEnabledElement(targetElement);

      if (!targetElementStub || !targetElementStub.image) {
        return;
      }

      //const targetImageId = targetElementStub.image.imageId;
      const targetImageId = targetElementStub.image.sopInstanceUID;
      const targetSeriesKey = makeKey(
        targetElementStub.image.seriesInstanceUID,
        targetElementStub.image.modality
      );

      //initialData.imageIds.targetElements.push(targetImageId);
      //initialData.imageIds.targetElements.push(targetElement);
      initialData.imageIds.mapSourceToTargets[sourceElement].push(
        targetElement
      );

      if (sourceElement === targetElement) {
        return;
      }

      if (
        initialData.distances[sourceElement.id].hasOwnProperty(targetElement.id)
      ) {
        return;
      }
      let metadataCache = new Cache.Metadata();
      const targetImagePlane = metadataCache.getImagePlaneModule(
        targetSeriesKey
      );
      targetImagePlane.imagePositionPatient =
        targetElementStub.image.imagePosition;

      if (!targetImagePlane || !targetImagePlane.imagePositionPatient) {
        return;
      }

      const targetImagePosition = math.vector.convertToVector3(
        targetImagePlane.imagePositionPatient
      );

      initialData.distances[sourceElement.id][
        targetElement.id
      ] = targetImagePosition.clone().sub(sourceImagePosition);

      // console.log("source element id : " + sourceElement.id);
      // console.log("target element id : " + targetElement.id);
      // console.log("source position : ");
      // console.log(sourceImagePosition);
      // console.log("target position : ");
      // console.log(targetImagePosition);
      // console.log("distance");
    });

    if (!Object.keys(initialData.distances[sourceElement.id]).length) {
      delete initialData.distances[sourceElement.id];
    }
  };

  /**
   * Gather necessary event data and call synchronization handler
   *
   * @private
   * @param {HTMLElement} sourceElement - The source element for the event
   * @param {Object} eventData - The data object for the source event
   * @returns {void}
   */
  function fireEvent(sourceElement, eventData) {
    const isDisabled = !that.enabled;
    const noElements = !sourceElement;

    if (isDisabled || noElements) {
      return;
    }

    ignoreFiredEvents = true;
    const targetElements = mapSourceToElements.get(sourceElement);

    if (targetElements) {
      targetElements.forEach(function (targetElement) {
        const targetIndex = targetElements.indexOf(targetElement);

        if (targetIndex === -1) {
          return;
        }

        //const targetImageId = initialData.imageIds.targetElements[targetIndex];
        let positionDifference;

        if (sourceElement === targetElement) {
          positionDifference = 0;
        } else if (initialData.distances[sourceElement.id] !== undefined) {
          positionDifference =
            initialData.distances[sourceElement.id][targetElement.id];
        }
        eventHandler(
          that,
          sourceElement,
          targetElement,
          eventData,
          positionDifference
        );
      });
    }
    ignoreFiredEvents = false;
  }

  /**
   * Call fireEvent if not ignoring events, and pass along event data
   *
   * @private
   * @param {Event} e - The source event object
   * @returns {void}
   */
  function onEvent(e) {
    const eventData = e.detail;

    if (ignoreFiredEvents === true) {
      return;
    }

    fireEvent(e.currentTarget, eventData);
  }

  this.add = function (sourceElement, targetElements) {
    // 이전에 맵에 source element가 추가된적이 없다면, 맵에 빈리스트와 함께 추가한다.
    if (!mapSourceToElements.has(sourceElement)) {
      mapSourceToElements.set(sourceElement, []);
    }

    targetElements.forEach((element) => {
      let addedTargetElements = mapSourceToElements.get(sourceElement);
      const index = addedTargetElements.indexOf(element);
      if (index === -1) {
        addedTargetElements.push(element);
        //mapSourceToElements[sourceElement].push(element);
      }
    });

    // 이벤트를 리스너를 등록한다.
    event.split(" ").forEach((oneEvent) => {
      sourceElement.addEventListener(oneEvent, onEvent);
    });

    // Update the initial distances between elements
    that.getDistances(sourceElement);
    that.updateDisableHandlers(sourceElement);
  };
  this.registerEventListener = function (element) {
    const containerElement = element;
    if (Helper.Validator.isDefined(containerElement) === false) {
      Helper.Except.throw("containerElement is not defined");
      return false;
    }
    _containerElement = containerElement;
    // 이벤트를 리스너를 등록한다.
    //const gridDCMViewElement = getGridDCMViewElement();
    if (Helper.Validator.isDefined(_containerElement) === false) {
      return;
    }
    event.split(" ").forEach((oneEvent) => {
      _containerElement.addEventListener(oneEvent, onEvent);
    });
  };
  this.unregisterEventListener = function (element) {
    const containerElement = element;
    if (Helper.Validator.isDefined(containerElement) === false) {
      Helper.Except.throw("containerElement is not defined");
      return false;
    }
    _containerElement = containerElement;
    // 이벤트를 리스너를 등록한다.
    //const gridDCMViewElement = getGridDCMViewElement();
    if (Helper.Validator.isDefined(_containerElement) === false) {
      return;
    }
    event.split(" ").forEach((oneEvent) => {
      _containerElement.removeEventListener(oneEvent, onEvent);
    });
  };
  /**
   * Remove a source element from this synchronizer
   *
   * @param {HTMLElement} element - The element to be removed
   * @returns {void}
   */
  this.removeSource = function (element) {
    // 만약, map에 등록되지 않은 element라면, 함수를 종료한다.
    if (!mapSourceToElements.has(element)) {
      return;
    }

    // Remove this element from the array
    mapSourceToElements[element] = [];
    mapSourceToElements.delete(element);

    // Stop listening for the event
    event.split(" ").forEach((oneEvent) => {
      element.removeEventListener(oneEvent, onEvent);
    });

    // Update the initial distances between elements
    //that.getDistances();
    that.initialDistance();

    // Update everyone listening for events
    fireEvent(element);
    that.updateDisableHandlers();
  };

  this.removeTarget = function (removeElement) {
    mapSourceToElements.forEach(function (targetElements, sourceElement) {
      mapSourceToElements.set(
        sourceElement,
        targetElements.filter(function (targetElement, index, self) {
          if (targetElement === removeElement) {
            targetElement.removeEventListener(
              EVENTS.ELEMENT_DISABLED,
              disableHandler
            );
            return false;
          }
          return true;
        })
      );
    });
  };

  /**
   * Remove an element from this synchronizer as both a target and source
   *
   * @param {HTMLElement} element - The element to be removed
   * @returns {void}
   */
  this.remove = function (element) {
    that.removeTarget(element);
    that.removeSource(element);
  };

  /**
   * Get the array of source elements
   *
   * @returns {HTMLElement[]}
   */
  this.getSourceElements = function () {
    return mapSourceToElements.keys();
    //return sourceElements;
  };

  /**
   * Get the array of target elements
   *
   * @returns {HTMLElement[]}
   */
  this.getTargetElements = function (sourceElement) {
    return mapSourceToElements.get(sourceElement);
    //return targetElements;
  };

  /**
   * Display an image while halting synchronization
   *
   * @param {HTMLElement} element - The element containing the image
   * @param {Object} image - The cornerstone image object
   * @param {Object} viewport - The cornerstone viewport object
   * @returns {void}
   */
  this.displayImage = function (element, image, viewport) {
    ignoreFiredEvents = true;
    //cornerstone.displayImage(element, image, viewport);
    ignoreFiredEvents = false;
  };

  /**
   * Update a viewport while halting synchronization
   *
   * @param {HTMLElement} element - The target element
   * @param {Object} viewport - The new cornerstone viewport object
   * @returns {void}
   */
  this.setViewport = function (element, viewport) {
    ignoreFiredEvents = true;
    ignoreFiredEvents = false;
  };

  /**
   * Remove an element from the synchronizer based on an event from that element
   *
   * @private
   * @param {Event} e - The event whose element will be removed
   * @returns {void}
   */
  function disableHandler(e) {
    const element = e.detail.element;

    that.remove(element);
    //clearToolOptionsByElement(element);
  }

  /**
   * Add an event listener to each element that can remove it from the synchronizer
   * @returns {void}
   */
  this.updateDisableHandlers = function (sourceElement) {
    const targetElements = mapSourceToElements.get(sourceElement);
    if (!targetElements) {
      return;
    }
    const elements = unique(targetElements.concat(sourceElement));

    elements.forEach(function (element) {
      element.removeEventListener(EVENTS.ELEMENT_DISABLED, disableHandler);
      element.addEventListener(EVENTS.ELEMENT_DISABLED, disableHandler);
    });
  };

  /**
   * Remove all elements from this synchronizer
   *  @returns {void}
   */
  this.destroy = function () {
    ///const elements = unique(sourceElements.concat(targetElements));
    //const sourceElements = unique(mapSourceToElements.keys());
    //const sourceElements = mapSourceToElements.keys() || [];
    const sourceElements = [...mapSourceToElements.keys()];

    sourceElements.forEach(function (element) {
      that.remove(element);
    });
  };
}

export default Synchronizer;
